export const SET_MODULE_STUDENTS = 'SET_MODULE_STUDENTS'
export const GET_HOMEWORK_DETAILS = 'GET_HOMEWORK_DETAILS'
